import React from 'react';
import {useForm} from "react-hook-form";
import {Form} from "react-bootstrap";
import axios from "../../../helpers/axios";

const CreateCategoryForm = ({child,somthingWithCategory}) => {
  const {handleSubmit,
    reset,
    register} = useForm()

  const onSubmit = (data) =>{
    console.log('dataform', {...data, child, type: 'add'})
    const send = {...data, type: 'add'}
    if(window.confirm('Создать новую категорию?')){
      if(child) {
        somthingWithCategory({...send, child})
      }else{
        somthingWithCategory(send)
      }
    }
    reset()
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={'d-flex align-items-center gap-2 p-2'}>
      <Form.Control
        name={'search'}
        defaultValue={''}
        className={'form-control'}
        type={'text'}
        {...register('name', {required: true})}
        placeholder="Добавить новую категорию"
      />
      <i className={'fa fa-plus pointer'} onClick={handleSubmit(onSubmit)}/>
    </form>
  );
};

export default CreateCategoryForm;
